import {
  TMockExamAttempt,
  TMockExamListItem,
  TMockExamLastAttempt,
  TMockExamSessionSubject,
  TMockExamResultSubject,
  TMockExamDetailAttemptDto,
  TMockExamListItemDto,
  TStartSubjectDto,
  TReviewSubjectDto,
} from "@/infrastructure/adapters/mock-exam/mock-exam.types";
import { DATE_FORMAT } from "@/constants/datetime";
import { dayjs } from "@/utils/dayjs";
import { makeUuid } from "@/utils/pieces";

// ─── Mapper Functions ───────────────────────────
export const mapAttempt = (dto: TMockExamDetailAttemptDto): TMockExamAttempt => ({
  attemptId: dto.attemptId,
  date: dayjs(dto.startedAt).format(DATE_FORMAT),
  grade: dto.grade,
  scorePercentage: dto.scorePercentage ?? 0,
  correctAnswers: dto.correctCount ?? 0,
  totalQuestions: dto.totalQuestions,
  timeSpentSeconds: dto.timeSpentSeconds,
});

export const mapListItem = (dto: TMockExamListItemDto): TMockExamListItem => {
  const totalScore = dto.totalScore ?? 0;
  const passingScore = dto.passingScore ?? 0;
  const passingScorePercentage = totalScore > 0 ? Math.round((passingScore / totalScore) * 100) : 0;

  let lastAttempt: TMockExamLastAttempt | null = null;
  const attempt = dto.lastAttempt;
  if (attempt) {
    lastAttempt = {
      date: dayjs(attempt.startedAt).format(DATE_FORMAT),
      grade: attempt.grade,
      scorePercentage: attempt.scorePercentage,
    };
  }

  return {
    mockExamId: dto.mockExamId,
    name: dto.name,
    timeLimitMinutes: dto.examDuration ?? 0,
    passingScorePercentage,
    lastAttempt,
  };
};

export const mapStartSubject = (dto: TStartSubjectDto): TMockExamSessionSubject => ({
  subjectName: dto.subjectName,
  subjectId: makeUuid(),
  questions: dto.questions.map((q) => ({
    questionId: q.questionId,
    questionText: q.questionText,
    imageFile: q.imageFile,
    choices: q.choices.map((c) => ({
      choiceId: makeUuid(),
      choiceText: c,
    })),
  })),
});

export const mapReviewSubject = (dto: TReviewSubjectDto): TMockExamResultSubject => ({
  subjectName: dto.subjectName,
  subjectId: makeUuid(),
  items: dto.questions.map((q) => ({
    questionId: q.questionId,
    displayOrder: q.displayOrder,
    questionText: q.questionText,
    translatedQuestionText: q.translatedQuestionText ?? null,
    imageFile: q.imageFile,
    isCorrect: q.isCorrect ?? false,
    selectedOption: q.selectedAnswer,
    correctOption: q.correctAnswer,
    explanation: q.explanation ?? "",
    translatedExplanation: q.translatedExplanation ?? null,
    options: q.choices,
    translatedOptions: q.translatedChoices ?? null,
  })),
});
